import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    padding: "32px",
  },
  tabDetails: {
    padding: "8px !important",
  },
  customerContainerTabs: {
    display: "flex",
    position: "relative",
    flexDirection: "row",
    width: "100%",
    gap: "12px",
  },
  uiTab: {
    height: "100% !important",
    minHeight: "calc(100vh - 310px) !important",
  },
}));

export default styles;
